"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentFactory = void 0;
const CheckoutRequestHandler_1 = require("../requestHandlers/CheckoutRequestHandler");
class PaymentFactory {
    /**
     * Get available payment methods.
     * @param {number} shopId
     * @param {string} checkoutId
     * @returns {Promise<IPaymentData[]>}
     */
    static getPaymentMethods(shopId, checkoutId) {
        return __awaiter(this, void 0, void 0, function* () {
            return CheckoutRequestHandler_1.CheckoutRequestHandler.getPayments(shopId, checkoutId);
        });
    }
    /**
     * Sets the give payment method.
     * @param {number} shopId
     * @param {string} checkoutId
     * @param {ICheckoutPutParams} payload
     * @returns {Promise<ICheckoutData>}
     */
    static setPaymentMethod(shopId, checkoutId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return CheckoutRequestHandler_1.CheckoutRequestHandler.putParams(shopId, checkoutId, payload);
        });
    }
    /**
     * Initializes payment for the given checkout.
     * @param {string} shopId
     * @param {string} checkoutId
     * @param amazonPayOrderReferenceId
     * @returns {Promise<IPaymentTransaction>}
     */
    static initPayment(shopId, checkoutId, amazonPayOrderReferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            return CheckoutRequestHandler_1.CheckoutRequestHandler.initializePayment(shopId, checkoutId, amazonPayOrderReferenceId);
        });
    }
    /**
     * Returns a token for usage with braintree payment API.
     * @returns {Promise<{clientToken: string}>}
     */
    static getBraintreeToken(currencyCode) {
        return __awaiter(this, void 0, void 0, function* () {
            return CheckoutRequestHandler_1.CheckoutRequestHandler.getBraintreeToken(currencyCode);
        });
    }
    static amazonPayPreAuthorize(paymentTransactionId, successUrl, failureUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            return CheckoutRequestHandler_1.CheckoutRequestHandler.amazonPayPreAuthorize(paymentTransactionId, successUrl, failureUrl);
        });
    }
    static getAmazonPayAddress(orderReferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            return CheckoutRequestHandler_1.CheckoutRequestHandler.getAmazonPayAddress(orderReferenceId);
        });
    }
    /**
     * Authorizes a payment for execution.
     * @param {string} paymentTransactionId
     * @param braintreeNonce
     * @returns {Promise<IPaymentTransaction>}
     */
    static authorizePayment(paymentTransactionId, braintreeNonce) {
        return __awaiter(this, void 0, void 0, function* () {
            return CheckoutRequestHandler_1.CheckoutRequestHandler.authorizePayment(paymentTransactionId, braintreeNonce);
        });
    }
}
exports.PaymentFactory = PaymentFactory;
